<template><!-- svgo-optimised -->
<svg class="icon icon__grid-one" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M2 2h20v20H2zm.75.75v18.5h18.5V2.75z" fill-rule="evenodd" clip-rule="evenodd"/></svg></template>